// extracted by mini-css-extract-plugin
var _1 = "NavButton-module__disabled--Xif1K";
var _2 = "NavButton-module__iconOuter--dNAW6";
var _3 = "NavButton-module__label--YxySE CoreGeneral__robotoSlab--X8lgW";
var _4 = "NavButton-module__selected--JyiKW";
var _5 = "NavButton-module__underline--aPttb";
export { _1 as "disabled", _2 as "iconOuter", _3 as "label", _4 as "selected", _5 as "underline" }
